import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { renderInlineCssVars, useDesignTokens } from '../../../theme';
import bundle from '../NovaComponents-ObjectMarker-gui-icu.properties';
import cn from './PopperContent.css.json';
import './PopperContent.css';
import { jsx as _jsx } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const PopperContent = props => {
  const dt = useDesignTokens();
  const tokens = renderInlineCssVars({
    pd: dt.tokens['space-base-m'],
    'font-size-m': dt.tokens['font-size-body-text-m']
  }, 'object-marker');
  const localize = useTextLocalizer();
  const informationLabel = localize('information.label');
  return /*#__PURE__*/_jsx("div", {
    className: cn.container,
    role: "dialog",
    "aria-label": informationLabel,
    children: /*#__PURE__*/_jsx("div", {
      className: cn.popperContent,
      style: tokens,
      tabIndex: 0
      // eslint-disable-next-line @sas/i18n/jsx-to-localize
      ,
      onKeyDown: event => event.key === 'Escape' && props.onEscape?.(),
      children: props.content
    })
  });
};
//# sourceMappingURL=PopperContent.js.map